var map = {
	"./1.jpg": "9137",
	"./2.jpg": "abe9",
	"./3.jpg": "e731",
	"./4.jpg": "692c",
	"./5.jpg": "e22c",
	"./6.jpg": "ae31"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ff5f";